export default __webpack_public_path__ + "static/media/weSolvvoLogoMotto.e21de293.png";